import { DEV } from "solid-js"
import { Vector3 } from "three"
import { freeze } from "../../../core/util/Object"
import Unexpected from "../../../Exception/Unexpected.class"

/**
 * Weighted interpolation of current at an arbitrary point inside a tile.
 *
 * @param weights   WeightsV2 from calculateNeighborWeights
 * @param currents  CurrentsV2 for base + 8 neighbours
 * @returns         The interpolated current
 */
export default function createNodeNeighborAvgWaterCurrentListV1(
  base: Vector3,
  list: Vector3[], // length === 8
): Vector3[] {

  if (DEV) {
    if (list.length !== 8) {
      throw new Unexpected('list.length !== 8')
    }
  }

  const [
    northCurrent,
    northEastCurrent,
    eastCurrent,
    southEastCurrent,
    southCurrent,
    southWestCurrent,
    westCurrent,
    northWestCurrent,
  ] = list

  const northCurrentAvg = base.clone().add(northCurrent).divideScalar(2)
  const eastCurrentAvg = base.clone().add(eastCurrent).divideScalar(2)
  const southCurrentAvg = base.clone().add(southCurrent).divideScalar(2)
  const westCurrentAvg = base.clone().add(westCurrent).divideScalar(2)

  const northWestCurrentAvg = base.clone().add(northCurrent).add(westCurrent).add(northWestCurrent).divideScalar(4)
  const northEastCurrentAvg = base.clone().add(northCurrent).add(eastCurrent).add(northEastCurrent).divideScalar(4)
  const southWestCurrentAvg = base.clone().add(southCurrent).add(westCurrent).add(southWestCurrent).divideScalar(4)
  const southEastCurrentAvg = base.clone().add(southCurrent).add(eastCurrent).add(southEastCurrent).divideScalar(4)

  const avgs = [
    northCurrentAvg,
    northEastCurrentAvg,
    eastCurrentAvg,
    southEastCurrentAvg,
    southCurrentAvg,
    southWestCurrentAvg,
    westCurrentAvg,
    northWestCurrentAvg,
  ]
  if (DEV) {
    freeze(avgs)
  }
  return avgs
}
